export default {
    publishableKey: 'pk_test_51HlsLOJWCRYG3ktvqDQMCDf9mujsaUSKkzj8tuJaTlXh3Cxehwbbcw8hXGTLLSy8znRBFruQaP94xzMb2GgwyXNe001stwr1Bl'
}